import { render, staticRenderFns } from "./404Redirect.vue?vue&type=template&id=33a56898&scoped=true"
import script from "./404Redirect.vue?vue&type=script&lang=js"
export * from "./404Redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a56898",
  null
  
)

export default component.exports